// extracted by mini-css-extract-plugin
export default {"root":"LJAhBN","img":"RpgmlQ"};